<template>
  <button class="flex flex-row items-center border-r border-primary pt-2">
    <div class="flex gap-1 items-center text-md whitespace-nowrap">
      <Cat v-if="pet.category.slug == 'cat'" :class="isActive ? 'text-white' : 'text-primary'" :size="16" />
      <Dog v-else :class="isActive ? 'text-white' : 'text-primary'" :size="16" />
      {{ pet.name || pet.category.name }}
    </div>
    <Dot />
  </button>
</template>

<script lang="ts" setup>
import {Pet} from "@/customer/interfaces/Pet";
import {Cat, Dog, Dot} from "@lucide/vue";
import {useRoute} from "vue-router";
import {computed} from "vue";

const route = useRoute();

defineProps<{
    pet: Pet
}>();

const isActive = computed(() => {
    return route.name === 'customer.beneficiary' || route.name === 'customer.pet' || route.name == 'customer.pet.create';
});

</script>

<style scoped>
.dot {
  @apply rounded-full bg-orange w-3 absolute h-3;
  top: -4px;
  right: 3px;
}
</style>
